import React, { memo } from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { Text } from '@atlaskit/primitives/compiled';
import { EmptyFieldText } from '@atlassian/jira-issue-empty-field-text/src/ui/index.tsx';
import type { ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView$key } from './__generated__/ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView.graphql';

export type ReadViewProps = {
	fieldRef: ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView$key;
};

export const LinkRelationshipTypeReadView = memo<ReadViewProps>(({ fieldRef }) => {
	const data =
		useFragment<ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView$key>(
			// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
			graphql`
				fragment ui_IssueFieldLinkRelationshipReadviewFull_LinkRelationshipTypeReadView on JiraIssueLinkRelationshipTypeField {
					issueLink {
						relationName
					}
				}
			`,
			fieldRef,
		);

	const relationName = data?.issueLink?.relationName;

	if (!relationName) {
		return <EmptyFieldText />;
	}

	return <Text testId="issue-field-link-relationship-readview-full.ui.text">{relationName}</Text>;
});
